"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../../ControlRendererContext"));
const Badge = ({ text, fontSize, bgColor, textColor, }) => {
    const { Render, functions: { processor } } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const [height, setHeight] = (0, react_1.useState)(fontSize + 14);
    const platform = processor.root.platformOS;
    const handleOnLayout = (0, react_1.useCallback)(({ nativeEvent: { layout } }) => {
        setHeight(layout.height);
    }, []);
    const isMobile = platform !== 'web';
    const offset = -(height / 2);
    return (react_1.default.createElement(Render.Text, Object.assign({}, isMobile && { onLayout: handleOnLayout }, { style: {
            color: textColor || 'white',
            fontSize,
            position: 'absolute',
            right: offset,
            top: offset,
            minWidth: height,
            borderRadius: height / 2,
            padding: 5,
            overflow: 'hidden',
            textAlign: 'center',
            backgroundColor: bgColor || 'red',
        } }), text));
};
Badge.defaultProps = {
    text: '',
};
exports.default = Badge;
